import React, { createContext, useState } from 'react';

interface IAppContextType {
  currency: ICurrency;
  setCurrency: (arg: ICurrency) => void;
}

export interface ICurrency {
  currency_id: string;
  network: string;
}

const initiallAppContext: IAppContextType = {
  currency: { currency_id: '', network: '' },
  setCurrency: () => {},
};

export const AppContext = createContext<IAppContextType | any>({});

interface IPropsAppProvider {
  children: React.ReactNode;
}

export const AppProvider: React.FC<IPropsAppProvider> = ({ children }) => {
  const [currency, setCurrency] = useState<ICurrency>(initiallAppContext.currency);

  return <AppContext.Provider value={{ currency, setCurrency }}>{children}</AppContext.Provider>;
};
